var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasinoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.725,
    height: 22.923,
    viewBox: "0 0 28.725 22.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2468",
    "data-name": "Group 2468",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_2_2-03_1_",
    "data-name": "icon 2 2-03 (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M-163.016-37.975h-17.261a.938.938,0,0,1-.937-.937v-21.05a.937.937,0,0,1,.937-.936h26.852a.936.936,0,0,1,.936.936v21.05a.937.937,0,0,1-.936.937Zm8.654-1.873v-5.705h-7.718v5.705Zm-9.591,0V-59.025h-6.767v19.177Zm-15.388,0h6.758V-59.025h-6.759Zm17.261-7.578h7.718v-11.6h-7.718Zm-6.47.947,1.318-4.924h-1.755v-1.415h3.731l-1.66,6.339Zm-8.59,0,1.272-4.924h-1.758v-1.415h3.77l-1.7,6.339ZM-159.873-49l1.31-4.924h-1.756v-1.416h3.733l-1.7,6.34Z",
    transform: "translate(180.964 60.648)",
    fill: "#a4c84e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasinoIcon);
export default __webpack_public_path__ + "static/media/casinoIcon.bb5b904c1a37ff842f9dfb72ceb5b8ef.svg";
export { ForwardRef as ReactComponent };